import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider.tsx";
import Login from "./pages/Login.tsx";
import Profile from "./pages/Profile.tsx";
import Application from "./pages/Application.tsx";
import Applications from "./pages/Applications.tsx";
import AdminProfile from "./pages/Admin-Profile.tsx";
import AdminProfiles from "./pages/Admin-Profiles.tsx";
import AdminApplication from "./pages/Admin-Application.tsx";
import AdminApplications from "./pages/Admin-Applications.tsx";
import AdminSearch from "./pages/Admin-Search.tsx";
import Support from "./pages/Support.tsx";
import PrivateRoute from "./components/PrivateRoute.tsx";
import AdministratorRoute from "./components/AdministratorRoute.tsx";
import Password from "./pages/Password.tsx";
import Privacy from "./pages/Privacy.tsx";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
         <Routes>
            <Route index element={<Login isAdministrator={false} />} />
            <Route path="/password/:resetId" element={<Password />} />            
            <Route path="/applications" element={<PrivateRoute><Applications /></PrivateRoute>} />
            <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            <Route path="/application/:applicationId" element={<PrivateRoute><Application /></PrivateRoute>} />
            <Route path="/application" element={<PrivateRoute><Application /></PrivateRoute>} />
            <Route path="/support" element={<PrivateRoute><Support /></PrivateRoute>} />
            <Route path="/admin" element={<Login isAdministrator={true} />} />
            <Route path="/admin/profile/:businessId" element={<AdministratorRoute><AdminProfile /></AdministratorRoute>} />
            <Route path="/admin/profile" element={<AdministratorRoute><AdminProfile /></AdministratorRoute>} />
            <Route path="/admin/profiles" element={<AdministratorRoute><AdminProfiles /></AdministratorRoute>} />
            <Route path="/admin/applications" element={<AdministratorRoute><AdminApplications /></AdministratorRoute>} />
            <Route path="/admin/application/:applicationId" element={<AdministratorRoute><AdminApplication /></AdministratorRoute>} />            
            <Route path="/admin/search" element={<AdministratorRoute><AdminSearch /></AdministratorRoute>} />
            <Route path="/admin/support" element={<AdministratorRoute><Support /></AdministratorRoute>} />
            <Route path="/privacy" element={<Privacy />} />            
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);